import React from "react";

class Verify extends React.Component {
  componentDidMount() {}
  render() {
    const userAgent = window.navigator.userAgent;
    return (
      <div>
        <section className="login-section mt-5">
          <div className="container">
            <div className="row">
              <div className="col-sm-3" />
              <div className=" col-sm-6">
                <div className="card all-card login-card">
                  <div className="content">
                    <div className="text-center" style={{ paddingBottom: 20 }}>
                      <a>
                        <img src="data:image/png;base64,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" />
                      </a>
                    </div>
                    <div className="text-center m-2">
                      <h3>Verification Successful</h3>
                      <p>Your email address has been verified successfully.</p>
                      <p>
                        <a
                          href="https://app.kochure.com"
                          className="btn btn-success text-white"
                          style={{
                            background: "#1427A8",
                          }}
                        >
                          Continue with Web
                        </a>
                      </p>

                      <p>
                        <a
                          href={
                            userAgent.includes("iPhone")
                              ? "https://apps.apple.com/ng/app/kochure/id1595574962"
                              : "https://play.google.com/store/apps/details?id=com.kochure.kochureApp"
                          }
                          className="btn btn-primary text-white"
                        >
                          Continue On App
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-3" />
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default Verify;
